import { UserUpdateRequest } from '@playq/octopus2-auth';
import { CommonSuccess, GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

type UpdateCredentialsPayload = {
  userData: UserUpdateRequest;
};

export const userProfileKey = ['profile', 'update', 'user'];

export const useUpdateProfile = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, UpdateCredentialsPayload>
) =>
  useEitherMutation(({ userData }: UpdateCredentialsPayload) => services2.userProfileService.update(userData), {
    mutationKey: userProfileKey,
    ...options,
  });
